import { render, staticRenderFns } from "./room_view_bold_theme.html?vue&type=template&id=7f2580e4&external"
import script from "./room_view_bold_theme.vue?vue&type=script&lang=js"
export * from "./room_view_bold_theme.vue?vue&type=script&lang=js"
import style0 from "./room_view_bold_theme.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports